import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["focusedValue", "valueFormatter", "interval", "makeOptionId", "max", "min", "onOptionClick", "onOptionHover"];
import { PrivateTimePickerOption } from './PrivateTimePickerOption';
import { syntheticEvent } from '../../utils/SyntheticEvent';
import { range } from '../../utils/range/range';
import partial from 'react-utils/partial';
import { filterProps } from '../../../utils/filterProps';
import { TypeaheadResults } from '../Typeahead';
import { PureComponent } from 'react';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export class PrivateTimePickerOptions extends PureComponent {
  render() {
    const _this$props = this.props,
      {
        focusedValue,
        valueFormatter,
        interval,
        makeOptionId,
        max,
        min,
        onOptionClick,
        onOptionHover
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      domProps,
      callbackProps
    } = filterProps(rest);

    // Use the closest interval multiple as the min/max in the dropdown (see #7688)
    const computedMin = Math.ceil(min / interval) * interval;
    const computedMax = (Math.floor(max / interval) + 1) * interval;
    return /*#__PURE__*/_jsx(TypeaheadResults, {
      children: range(computedMin, computedMax, interval).map(value => /*#__PURE__*/_createElement(PrivateTimePickerOption, Object.assign({}, domProps, callbackProps, {
        key: value,
        id: makeOptionId(value),
        valueFormatter: valueFormatter,
        highlighted: value === focusedValue,
        value: value,
        onMouseDown: evt => {
          /* This handler is passed as onMouseDown instead of onClick so that it fires before
          the parent component's input's `blur` event */
          if (onOptionClick) {
            onOptionClick(syntheticEvent(value, evt));
          }
        },
        onMouseEnter: partial(onOptionHover, value)
      })))
    });
  }
}